import axios from 'axios';
import LoginService from '../acesso/login.service';

const API_URL = process.env.VUE_APP_BASE_URL + '/api/consultaRps/';

class NotaFiscalRpsService {
	constructor() {
		LoginService.currentUser.subscribe(data => {
			this.headers = {
				'Content-Type': 'application/json',
				'authorization': 'Bearer ' + (data ? data.token : '')
			};
		});
	}

	findAllNotasRps(idUsuarioContr, idCliente, dataRecebimentoIni, dataRecebimentoFin, numeroLote) {
		return axios.get(API_URL
			+ 'allNotasRps?idUsuario=' + idUsuarioContr
			+ '&idCliente=' + idCliente
			+ '&dataRecebimentoIni=' + dataRecebimentoIni
			+ '&dataRecebimentoFin=' + dataRecebimentoFin
			+ '&numeroLote=' + numeroLote, { headers: this.headers }).then(response => (this.data = response.data));
	}

	processar(lote) {
		this.idCliente = LoginService.currentUserValue.usuario.idCliente;
		this.idContribuinte = LoginService.currentUserValue.contribuinte.idContribuinte;
		lote.idCliente = this.idCliente;
		lote.idContribuinte = this.idContribuinte;
		console.log(lote);
		return axios.post(API_URL + 'create', JSON.stringify(lote),
			{ headers: this.headers });
	}
}
export default new NotaFiscalRpsService();